import React from 'react'
import ReactDOM from 'react-dom'
import CustomMuiDatepicker from '../ReactComponents/Components/CustomMuiDatepicker'

angular.module('common.directives').directive('customDatepicker', function () {
  return {
    scope: {
      selectedDate: '=',
      dateChange: '=',
      monthChange: '=',
      higlightDates: '='
    },
    template: '<div class="custom-element"></div>',
    link: ($scope, $element) => {
      const linkStateUpdater = stateUpdater => {
        $scope.$watch('higlightDates', () => {
          stateUpdater(Math.random())
        })
      }
      const handleDateChange = date => {
        $scope.selectedDate = date
        $scope.dateChange && $scope.dateChange(date)
        $scope.$apply()
      }
      const handleMonthChange = date => {
        $scope.monthChange && $scope.monthChange(date)
        $scope.$apply()
      }
      ReactDOM.render(
        <CustomMuiDatepicker
          getSelectedDate={() => $scope.selectedDate || new Date()}
          dateChange={date => handleDateChange(date)}
          monthChange={date => handleMonthChange(date)}
          getHiglightDates={() => $scope.higlightDates || []}
          linkStateUpdater={linkStateUpdater}
        />,
        $element[0]
      )
      $scope.$on('$destroy', () => {
        ReactDOM.unmountComponentAtNode($element[0])
      })
    }
  }
})
